import React from 'react';

interface LabelProps
  extends React.DetailedHTMLProps<
    React.LabelHTMLAttributes<HTMLLabelElement>,
    HTMLLabelElement
  > {}

/**
 * A form label.
 *
 * `htmlFor` is forwarded. It used to be destructured out of `props` and then never
 * applied, so all 112 `<Label htmlFor="...">` call sites across 27 files rendered a
 * `<label>` with no `for` attribute and no association to their input. Nothing looked
 * wrong — the text is still beside the field — but a screen reader announced every one
 * of those inputs as unlabelled, and clicking the label did not focus the field.
 * WCAG 2.2 SC 1.3.1 and SC 3.3.2. Found on 2026-09-26 by a test that could not find an
 * input via `getByLabelText`.
 *
 * Do not destructure a prop here unless you are doing something with it.
 */
export default function Label({
  children,
  className,
  ...props
}: LabelProps): JSX.Element {
  return (
    <label {...props} className={className ? className : 'title-label'}>
      {children}
    </label>
  );
}
